import React, { Component} from 'react';
 
import API from'../utilities/API'
import {Redirect  } from 'react-router-dom'
import SiteAgreement from '../container/Pages/Policies/SiteAgreement'
class Confirm extends Component {
 
  constructor(props) {
    super(props);
   console.log('PROPS',props);
//   this.state= {redirect: false};
    this.state= {email: this.props.match.params.email, onboardid: this.props.match.params.onboardin, redirect: false};
 



    this.handleAgree = this.handleAgree.bind(this);
     this.handleAgreeRedirect = this.handleAgreeRedirect.bind(this);
    
  
    
  }
  
  handleAgree(e)
  { 
    return API.autolog(this.state.onboardid, this.state.email,this.handleAgreeRedirect);  
  
   }

  handleAgreeRedirect(status)
  {
    console.log(status)
    try
    {
        if(status.data.status==='Good'){
          
            this.props.setUser(status.data.usr);
           
            this.setState({redirect:true});
           
             
      
          }
    }
    catch(err){console.log(err)}
     

  }
  
  

    render() { 

      return ((this.state.redirect)?<Redirect to='/'/>:<div className='mypage fluid-container p-3'>
                <h4>Please agree to our site terms by pressing the button below and you will have access to the sites features, free games and more...</h4>  
                {/* <p>Dear: { this.state.email}</p>
                <p>Your OnboardId: { this.state.onboardid}</p> */}
              
                <div className='row'>
                <div className="btn btn-dark mt-2" onClick={this.handleAgree} value="" to="/">Click here to acknowledge you have read and accepted the terms below.</div>
                </div>
                <SiteAgreement/>    
                <div className='row'>
                  <div className='col-12'>
                  
                  </div>
                  <div className="fluid-container m-3">



</div>
</div>
</div>
);            
              
  
      
    }  

  
}




export default Confirm; 


// WEBPACK FOOTER //
// ./src/components/Confirm.js